import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useDarkMode } from "@/hooks/useTheme";
import { classNames } from "@/utils";

const Cvf = "/images/cvf.png";
const XEurope = "/images/x_europe.png";
const p2020 = "/images/p2020.png";
const Calling2Scale = "/images/eit.png";
const WSA = "/images/WSA_logo.png";

const awards = [
  {
    image: Cvf,
    name: "WACV 2022",
    invert: true,
  },
  {
    image: XEurope,
    name: "X-EUROPE COHORT",
    invert: true,
  },
  {
    image: p2020,
    name: "PORTUGAL 2020 (P2020)",
    invert: true,
  },
  {
    image: Calling2Scale,
    name: "CALLING2SCALE BOOTCAMP",
    invert: false,
  },
  {
    image: WSA,
    name: "World Summit Awards Portugal 2023",
    subtitle: "#APDC #digitalbusinesscommunity #WSA #WSAPortugal",
    darkInvert: true,
    span: true,
  },
];

const CompanyAwards = () => {
  const { t } = useTranslation();
  const { theme } = useDarkMode();

  return (
    <motion.section
      className="py-20 md:py-24"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, margin: "-50px" }}
    >
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16 md:mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="inline-block mb-4">
            <span className="text-sm uppercase tracking-wider text-secondary-foreground font-medium">
              {t("AWARDS & NEWS")}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            {t("Award-winning projects")}
          </h2>
          <p className="text-xl md:text-2xl text-secondary-foreground max-w-4xl mx-auto leading-relaxed">
            {t(
              "Our work has been recognized at international conferences and we have been granted external funding to pursue our goals"
            )}
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {awards.map((award, index) => (
              <motion.div
                key={index}
                className={`bg-container-background border border-border rounded-2xl p-8 flex flex-col items-center justify-center text-center light_effect_card overflow-hidden relative group ${
                  award.span ? "md:col-span-2" : ""
                }`}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                {/* Content */}
                <div className="flex flex-col items-center">
                  <div className="h-20 mb-4 flex items-center justify-center">
                    <Image
                      className={classNames(
                        "h-20 w-auto object-contain transition-transform group-hover:scale-110",
                        theme === "dark"
                          ? award.darkInvert
                            ? "invert grayscale"
                            : ""
                          : award.invert
                          ? "invert"
                          : ""
                      )}
                      src={award.image}
                      alt={award.name}
                      width={200}
                      height={80}
                    />
                  </div>
                  <p className="text-secondary-foreground font-medium">
                    {award.name}
                  </p>
                  {award.subtitle && (
                    <p className="text-sm text-secondary-foreground/70 mt-2">
                      {award.subtitle}
                    </p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default CompanyAwards;
